export const permissionsSubscriptionsFull = [
  "subscriptions-full",
  "everything-full",
];
